module.exports = __webpack_public_path__ + "9c091cf4a79e972f0a40535cae0f8fd0.jpg";